import { CASPacketAttachmentOrderDefault } from '@cims-online/shared'

export const CustomDriveDefaultName = `Documents (System Default)`

export const CASPacketAttachmentOrderDefaultName = `${CASPacketAttachmentOrderDefault.name} (System Default)`
